import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const initializeSlice = createSlice({
  name: "initialize",
  initialState,
  reducers: {
    setInitialData: (state, { payload }) => ({ ...state, ...payload }),
    setLanguage: (state, { payload }) => {
      state.language = payload;
    },
  },
});

export const { setInitialData, setLanguage } = initializeSlice.actions;

export const InitializeSelector = (state) => state.initialize;
export const languageSelector = (state) => state.initialize.language;

export default initializeSlice.reducer;
